import { Iuser } from './Interface/Iuser';
import { UserService } from './Services/User.service';
import { Component, DoCheck, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from './Services/Token.service';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { SharedModule } from './SharedModule';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, DoCheck {
  user: Iuser = {} as Iuser;

  constructor(public token: TokenService, private router: Router) { }
  ngDoCheck(): void {
    // debugger;
    // \
    // if(typeof this.token.user   === 'undefined'){
    //   debugger;
    //   this.router.navigate(['/Login']);
    //   return;
    // }
    // this.token._userID.subscribe((value) => {
    //   debugger;
    //   if (!value) {
    //     this.router.navigate(['/Login']);
    //   }
    // });
  }
  ngOnInit(): void {
    this.token._userID.subscribe((value) => {
      if (!value) {
        this.router.navigate(['/Login']);
      } else {
        this.user = value;
      }
    });
  }
  Logout() {
    this.token.logout();
    this.router.navigate(['/Login']);
  }
}
